/* eslint-disable */
/////////////////////////////////////////////
////// Functions to manipulate cookies //////
/////////////////////////////////////////////
// cookie setter
function setCookie(cname, cvalue, exdays) {
 const d = new Date();
 d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
 const expires = `expires=${d.toUTCString()}`;
 document.cookie = `${cname}=${cvalue};${expires};path=/`;
}

// cookie getter
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    const later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export default {
  init() {
    // JavaScript to be fired on the Epionce Near You page
    // $('body').append('<script async defer src="https://maps.googleapis.com/maps/api/js?key=' + epionce_near_you.google_maps_api_key + '" type="text/javascript"></script>');

    ///////////////
    // FUNCTIONS //
    ///////////////
    function scrollToResult(index) {
      $('html, body').animate({scrollTop: $(`#pro-result-${index}`).offset().top - 10}, 1000);
    }

    // function for the dynamic map resizing to align with form height
    function google_map_resize() {
      const formHeight = $('.epionce-near-you__column--form').outerHeight();
      const map = $('#map');
      map.css({"height":`${formHeight}px`});
      if (map.hasClass('hidden')) {
        map.removeClass('hidden');
      }
    }

    // function for performing the AJAX request to fetch JSON object of professionals
    function getProfessionals(url, dataObj, security, action) {
      console.log(url);
      $.ajax({
        url: url,
        method: 'post',
        dataType: 'json',
        data: {'json': dataObj, 'security': security, 'action': action},
        success(response, textStatus, jqXhr) {
          console.log('dataObj: ', dataObj);
          if (response.status === 'success') {
            if (response.data.results > 0) {
              let rows = '';
              let finalIndex = 0;
              var radius = parseInt( parseFloat( response.data.radius ) / 1609.34 );
              response.data.data.forEach((element, index) => {
                // element is an object containing the properties of the professional
                if (radius > 25) {
                  element.show_connect_button = false;
                }

                if (element.distance !== 'Distance not available') {
                  element.distance += ' miles';
                }

                let connectButtonText = '';
                let connectedButtonClass = '';
                let connectButton = '';
                if (element.connected) {
                  connectButtonText = 'Saved';
                  connectedButtonClass = ' connected';
                  connectButton = `<div class="epionce-near-you__professional-listing__column--connect-button"><a href="#" id="connect-button_${element.pro_code}" class="epionce-near-you__professional-listing__connect-button${connectedButtonClass}">${connectButtonText}</a></div>`;
                } else if (element.show_connect_button) {
                  connectButtonText = 'Connect';
                  connectButton = `<div class="epionce-near-you__professional-listing__column--connect-button"><a href="#" id="connect-button_${element.pro_code}" class="epionce-near-you__professional-listing__connect-button${connectedButtonClass}">${connectButtonText}</a></div>`;
                } else {
                  connectButton = '<div class="epionce-near-you__professional-listing__column--connect-button bold" style="text-align:center"><i class="far fa-phone"></i> Call for Info</div>';
                }
                rows += `<div id="pro-result-${index+1}" class="epionce-near-you__row--table"><div class="epionce-near-you__professional-listing__column--number"><span class="epionce-near-you__professional-listing__number">${index+1}</span></div><div class="epionce-near-you__professional-listing__column--name"><p class="epionce-near-you__professional-listing__name">${element.business_name}</p></div><div class="epionce-near-you__professional-listing__column--address"><address class="epionce-near-you__professional-listing__address">${element.address}<br>${element.city}, ${element.state} ${element.zipcode}</address></div><div class="epionce-near-you__professional-listing__column--phone"><p class="epionce-near-you__professional-listing__phone">${element.phone_number}</p></div><div class="epionce-near-you__professional-listing__column--distance"><div class="epionce-near-you__professional-listing__distance">${element.distance}</div></div>${connectButton}</div>`;

                finalIndex = index+1;
              });

              // place listings header HTML
              $('.epionce-near-you__professional-listing-header').html(`Found <span class="epionce-near-you__professional-listing-header--bold">${finalIndex} Professionals</span>`);

              // load up dat map
              initMap(dataObj, response.data);

              // place listings HTML
              $('.epionce-near-you__column--professional-listings').html(rows);

            } else {
              // no results found

              // get the radius value used for search, in miles
              var radius = parseInt( parseFloat( response.data.radius ) / 1609.34 );

              // prepare message about no results in place of map
              let noResultsHtml = '<div class="epionce-near-you__map-loader">'+
                                    '<div class="epionce-near-you__map-loader__options">'+
                                      '<a class="epionce-near-you__map-loader__options__primary-button hidden" href="#">Automatically Find Location</a><br>'+
                                      '<p class="epionce-near-you__map-loader__options__or-text">No results found. Try a larger search radius.</p>'+
                                      '<a class="epionce-near-you__map-loader__options__secondary-button hidden" href="#">Click here to show a zip code field on the search form</a>'+
                                    '</div>'+
                                  '</div>';

              if ( radius === 25 ) {
                // no results found using largest radius allowed for Connect buttons to be present
                noResultsHtml = '<div class="epionce-near-you__map-loader">'+
                                      '<div class="epionce-near-you__map-loader__options">'+
                                        '<p class="epionce-near-you__map-loader__options__or-text">Thank you for your interest in Epionce!<br>Unfortunately, there is not a physician in your area retailing Epionce at this time.<br>Talk to your skin care professional about bringing Epionce closer to you.<br>To extend your search area, <a class="epionce-near-you__map-loader__options__extend-radius-button" data-radius="150" href="#">click here</a></p>'+
                                      '</div>'+
                                    '</div>';
              }

              if (radius === 150) {
                // no results found using largest radius allowed for Connect buttons to be present
                noResultsHtml = '<div class="epionce-near-you__map-loader">'+
                                      '<div class="epionce-near-you__map-loader__options">'+
                                        '<p class="epionce-near-you__map-loader__options__or-text">Thank you for your interest in Epionce!<br>Unfortunately, there is not a physician in your area retailing Epionce at this time.<br>Talk to your skin care professional about bringing Epionce closer to you.<br>To extend your search area, <a class="epionce-near-you__map-loader__options__extend-radius-button" data-radius="250" href="#">click here</a></p>'+
                                      '</div>'+
                                    '</div>';
              }

              if (radius === 250) {
                // no results found using largest radius allowed for Connect buttons to be present
                noResultsHtml = '<div class="epionce-near-you__map-loader">'+
                                      '<div class="epionce-near-you__map-loader__options">'+
                                        '<p class="epionce-near-you__map-loader__options__or-text">Thank you for your ongoing interest in Epionce!<br>Unfortunately, there is not a physician in your area retailing Epionce at this time.<br>Talk to your skin care professional about bringing Epionce closer to you.<br>Please contact us to be referred to an Epionce Professional that may be near you.<br><a href="/contact" style="display:inline-block;margin-top:1rem">Contact Us</a></p>'+
                                      '</div>'+
                                    '</div>';
              }


              // place listings header HTML
              $('.epionce-near-you__professional-listing-header').html('Found <span class="epionce-near-you__professional-listing-header--bold">0 Professionals</span>');

              // place message about no results in place of map
              $('#map').html(noResultsHtml);

              // reset the Search Button text

              // place listings HTML
              $('.epionce-near-you__column--professional-listings').html('');
            }

            $('#epionce-near-you-search-button').text('Search');

          } else {
            console.log("AJAX was successful, return status other than success...:/");
            console.log(textStatus);
          }
        },
        error(jqXhr, textStatus, errorThrown) {
          console.log(jqXhr);
          console.log(textStatus);
          console.log(errorThrown);
        }
      });
    }

    // get professionals by code
    function searchByProfessionalCode(pro_code) {

      if (typeof window.watchId !== 'undefined' && window.watchId !== null && window.watchId !== '') {
        navigator.geolocation.clearWatch(window.watchId); // stop refreshing by location if that was ever enabled
      }

      window.epionce_near_you_professional_code = pro_code;
      window.epionce_near_you_professional_name = null;

      const geo_options = {
        enableHighAccuracy: true,
        maximumAge        : 30000,
        timeout           : 30000
      };

      window.watchId = trackLocation(geo_options);
    }

    // get professionals by name
    function searchByProfessionalName(pro_name) {

      if (typeof window.watchId !== 'undefined' && window.watchId !== null && window.watchId !== '') {
        navigator.geolocation.clearWatch(window.watchId); // stop refreshing by location if that was ever enabled
      }

      window.epionce_near_you_professional_name = pro_name;
      window.epionce_near_you_professional_code = null;

      const geo_options = {
        enableHighAccuracy: true,
        maximumAge        : 30000,
        timeout           : 30000
      };

      window.watchId = trackLocation(geo_options);
    }

    // function for the automatic location tracking
    function trackLocation(geo_options) {
      // change up the map loader options primary button text while locating
      $('.epionce-near-you__map-loader__options__primary-button').addClass("disabled").text('Finding location...');
      $('#epionce-near-you-search-button').addClass("disabled").html('<i class="far fa-spinner fa-pulse"></i>');

      // kill any watchIds that may exist and start a new one
      if (typeof window.watchId !== 'undefined' && window.watchId !== null && window.watchId !== '') {
        navigator.geolocation.clearWatch(window.watchId);
      }

      return navigator.geolocation.watchPosition(geo_success, geo_error, geo_options);
    }

    // function for AJAX request to server to get professionals by zipcode, not location tracking
    function searchByZipcode(zipcode, radius) {

      if (typeof window.watchId !== 'undefined' && window.watchId !== null && window.watchId !== '') {
        navigator.geolocation.clearWatch(window.watchId); // stop refreshing by location if that was ever enabled
      }

      if (typeof $('#business-name').val() !== 'undefined' && $('#business-name').val() !== null && $('#business-name').val() !== '') {
        window.epionce_near_you_professional_name = $('#business-name').val();
      } else {
        window.epionce_near_you_professional_name = '';
      }

      if (typeof $('#professional-code').val() !== 'undefined' && $('#professional-code').val() !== null && $('#professional-code').val() !== '') {
        window.epionce_near_you_professional_code = $('#professional-code').val();
      } else {
        window.epionce_near_you_professional_code = '';
      }

      // create coordinates out of zipcode
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({
        address: zipcode,
        componentRestrictions: {
            country: "US"
        }
      }, (results, status) => {
        if (status === 'OK') {
          // format the data object for the AJAX request
          let coord_obj;
          if ( window.epionce_near_you_professional_name !== '' ) {
            coord_obj = {
              lat: results[0].geometry.location.lat(), // use lat() function because it a LatLng obj
              lng: results[0].geometry.location.lng(), // use lng() function because it a LatLng obj
              radius,
              professional_name: window.epionce_near_you_professional_name
            };
          } else {
            coord_obj = {
              lat: results[0].geometry.location.lat(), // use lat() function because it a LatLng obj
              lng: results[0].geometry.location.lng(), // use lng() function because it a LatLng obj
              radius
            };
          }

          // perform the AJAX request
          getProfessionals(epionce_near_you.ajaxUrl, coord_obj, epionce_near_you.nonce, 'find_professionals');
        }
      });
    }

    // function that uses setInterval to change the scale and opacity of the symbol at fixed intervals.
    function animateCircle(marker) {
        console.log("made it into animateCircle()");
        // console.log('marker: ', marker);
        let scaleCount = 0;
        window.setInterval(() => {
          scaleCount = ((scaleCount + 0.2) % 20);
          const circle = marker.get('icon');
          circle.scale = scaleCount;
          circle.fillOpacity = 1-(scaleCount/20);
          marker.set('icon', circle);
      }, 20);
    }

    // function to initialize the map using the coordinates gathered from the user and database
    function initMap(center_obj, pros_array) {
      var lat  = 43.60869435545244;
      var long = -116.30950257619176;

      if ((typeof center_obj.professional_code !== 'undefined' && center_obj.professional_code !== null && center_obj.professional_code !== '') || (typeof center_obj.professional_name !== 'undefined' && center_obj.professional_name !== null && center_obj.professional_name !== '')) {
        // initialize with any of the professionals coordinates because we will soon call fitBounds() to show all markers anyway
        if(! pros_array.data[0].lat){
          pros_array.data[0].lat = lat;
          pros_array.data[0].lng= long;
        }
        console.log("latitude: " +pros_array.data[0].lat);

        var map = new google.maps.Map(document.getElementById('map'), {
          center: {lat: parseFloat(pros_array.data[0].lat), lng: parseFloat(pros_array.data[0].lng)},
          zoom: Math.round(14-Math.log(1)/Math.LN2) // automatically calculate the amount of zoom based off radius
        });

        var oms = new OverlappingMarkerSpiderfier(map, {
          markersWontMove: true,
          markersWontHide: false,
          keepSpiderfied: true,
          nearbyDistance: 23
        });
  
      } else {
        if(!center_obj.lat){
          center_obj.lat = lat;
          center_obj.long = long;
        }
        // initialize with current location coordinates
        console.log("latitude: " +center_obj.lat);

        var map = new google.maps.Map(document.getElementById('map'), {
          center: {lat: parseFloat(center_obj.lat), lng: parseFloat(center_obj.lng)},
          zoom: Math.round(14-Math.log(1)/Math.LN2) // automatically calculate the amount of zoom based off radius
        });

        // the marker for current location
        const pulse_circle = {
          path: google.maps.SymbolPath.CIRCLE,
          fillColor: '#CE3262',
          fillOpacity: 1,
          strokeWeight: 0,
          scale: 10
        };

      
        // add the current location marker to the map
        var myLocationMarker = new google.maps.Marker({
          position: {lat: parseFloat(center_obj.lat), lng: parseFloat(center_obj.lng)},
          map,
          icon: pulse_circle
        });

        animateCircle(myLocationMarker);

        var oms = new OverlappingMarkerSpiderfier(map, {
          markersWontMove: true,
          markersWontHide: false,
          keepSpiderfied: true,
          nearbyDistance: 23
        });

      }

      // the marker for professionals
      const pro_circle = {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: '#CE3262',
        fillOpacity: 1,
        strokeWeight: 0,
        scale: 9.8
      };

      // add the professional markers to the map
      const locationMarkersArray = [];
      pros_array.data.forEach((element, index) => {
        // var locationMarker = new google.maps.Marker({
        //   position: {lat: parseFloat(element.lat), lng: parseFloat(element.lng)},
        //   map: map,
        //   icon: pro_circle,
        //   label: {
        //     text: (index+1).toString(),
        //     color: 'white',
        //     fontFamily: 'FF Meta W01',
        //     fontSize: '0.6rem',
        //     fontWeight: '300',
        //     labelStyle: {opacity:0.2}
        //   }
        // });

        var locationMarker = new MarkerWithLabel({
          clickable: true,
          draggable: false,
          position: {lat: parseFloat(element.lat), lng: parseFloat(element.lng)},
          map,
          // icon: pro_circle,
          labelClass: (index+1).toString(),
          labelContent: (index+1).toString(),
          labelAnchor: new google.maps.Point(4,30),
          labelStyle: {
            'textAlign':'center',
            'fontFamily':'FF Meta W01',
            'fontSize':'0.8rem',
            'fontWeight':'300',
            'color':'white'
          }
        });

        console.log('locationMarker: ', locationMarker);

        locationMarkersArray[index] = locationMarker;

        const contentString = `<div id="content"><div id="siteNotice"></div><h1 id="firstHeading" class="firstHeading" style="font-family:'FF Meta W01';font-size:1.6rem;">${element.business_name}</h1><div id="bodyContent"><address style="margin-bottom:5px;"><p style="margin-bottom:0px;"><b>${element.address}</b></p><p style="margin-bottom:0px;">${element.city}, ${element.state} ${element.zipcode}</p></address><a href="http://maps.google.com/?z=12&t=m&q=loc:${element.lat}+${element.lng}" target="_blank" style="font-size:0.7rem;font-style:italic;">View in Google Maps &raquo;</a><a href="#pro-result-${index+1}" id="connectLink" style="font-size:0.7rem;font-style:italic;padding:0 15px;">Connect with Professional</a></div></div>`;

        const infowindow = new google.maps.InfoWindow({
          content: contentString
        });

        oms.trackMarker(locationMarker, e => {
          infowindow.open(map, locationMarker);
        });

        oms.addListener('format', (marker, status) => {
          marker.status = status;
  
          marker.labelContent = '';
          marker.label.labelDiv_.innerHTML = '';
          marker.label.labelDiv_.innerText = '';
  
          if (status == 'SPIDERFIED') {
            var iconURL = `${epionce_near_you.marker_highlight}`;
            marker.labelContent = marker.labelClass;
            marker.label.labelDiv_.innerHTML = marker.labelClass;
            marker.label.labelDiv_.innerText = marker.labelClass;
          } else if (status == 'SPIDERFIABLE') {
            iconURL = `${epionce_near_you.marker_plus}`;
            marker.labelContent = '';
            marker.label.labelDiv_.innerHTML = '';
            marker.label.labelDiv_.innerText = '';
          } else if (status == 'UNSPIDERFIABLE') {
            iconURL = `${epionce_near_you.marker}`;
            marker.labelContent = marker.labelClass;
            marker.label.labelDiv_.innerHTML = marker.labelClass;
            marker.label.labelDiv_.innerText = marker.labelClass;
          } else {
            iconURL = null;
            marker.labelContent = marker.labelClass;
            marker.label.labelDiv_.innerHTML = marker.labelClass;
            marker.label.labelDiv_.innerText = marker.labelClass;
          }
  
          const iconSize = new google.maps.Size(23, 32);
  
          marker.setIcon({
            url: iconURL,
            scaledSize: iconSize  // makes SVG icons work in IE
          });
        });
      });

      const isIE = /*@cc_on!@*/false || !!document.documentMode;
      const isEdge = !isIE && !!window.StyleMedia;

      if (!isIE && !isEdge) {
        // var locationMarker = new MarkerWithLabel({
        //   clickable: true,
        //   draggable: false,
        //   position: {lat: parseFloat(element.lat), lng: parseFloat(element.lng)},
        //   map,
        //   // icon: pro_circle,
        //   labelClass: (index+1).toString(),
        //   labelContent: (index+1).toString(),
        //   labelAnchor: new google.maps.Point(4,30),
        //   labelStyle: {
        //     'textAlign':'center',
        //     'fontFamily':'FF Meta W01',
        //     'fontSize':'0.8rem',
        //     'fontWeight':'300',
        //     'color':'white'
        //   }
        // });

        // Inline this code
        // google.maps.event.addListener(infowindow, 'domready', function(){
        //   console.log('infowindow.content :', infowindow.content);
        //   var $infoWindowHTML = $(infowindow.content);
        //   console.log($infoWindowHTML.find('#content'));
        //   setTimeout(function(){
        //     $infoWindowHTML.find('#content').on('click', '#connectLink', function(e) {
        //       e.preventDefault();
        //       console.log('clicked');
        //       var proResultNum = $(this).attr('data-pro-result');
        //       $('body, html').animate({scrollTop:$('#pro-result-' + proResultNum).offset().top - 10},1000);
        //   })},1000);
        // });

        // locationMarker.addListener('click', function() {
        //   infowindow.open(map, locationMarker);
        // });

        // locationMarkersArray[index] = locationMarker;

        window.map = map;
        // window.oms = oms;

      }

      const bounds = new google.maps.LatLngBounds();
      for (let i = 0; i < locationMarkersArray.length; i++) {
        bounds.extend(locationMarkersArray[i].getPosition());
      }
      console.log('bounds: ', bounds);

      if ((typeof center_obj.professional_code !== 'undefined' && center_obj.professional_code !== null && center_obj.professional_code !== '') || (typeof center_obj.professional_name !== 'undefined' && center_obj.professional_name !== null && center_obj.professional_name !== '')) {
        if (locationMarkersArray.length > 1) {
          map.fitBounds(bounds); // make sure all markers are visible
        }
      } else {
        // add in the current location marker
        bounds.extend(myLocationMarker.getPosition());
        if (locationMarkersArray.length > 0) {
          map.fitBounds(bounds); // make sure all markers are visible
        }
      }


      // update the form buttons back to Search and Find My Location
      $('.epionce-near-you__map-loader__options__primary-button').text('Automatically Find Location');
      $('#epionce-near-you-search-button').html('Search');
    }

    // the event handler for when the location tracking call worked
    // 1. gathers data from database, 2. creates the list of pros below the map, and 3. initializes the map
    function geo_success(position) {
      // get the acquired coordinates
      // for testing with remote location
      // var lat = 39.4381245;
      // var lng = -116.9852422;
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      // get the search radius from the global or form
      let search_radius;
      if (typeof window.epionceNearYouSearchRadius !== 'undefined' && window.epionceNearYouSearchRadius !== null && window.epionceNearYouSearchRadius !== '') {
        search_radius = window.epionceNearYouSearchRadius;
      } else {
        search_radius = $('#search-radius').val();
      }

      // create the data obj to send to the server side
      const coord_obj = {
        professional_name: window.epionce_near_you_professional_name,
        professional_code: window.epionce_near_you_professional_code,
        lat,
        lng,
        radius: search_radius
      };

      // perform the AJAX request to gather professionals data and build HTML professionals list template
      getProfessionals(epionce_near_you.ajaxUrl, coord_obj, epionce_near_you.nonce, 'find_professionals');

      if (typeof window.watchId !== 'undefined' && window.watchId !== null && window.watchId !== '') {
        // stop refreshing by location to fix constant refresh issue in Firefox and Safari
        navigator.geolocation.clearWatch(window.watchId);
      }
    }

    // error event handler for when something went wrong with the location tracking function call
    // 1. adds the error message to the front end and 2. changes the text in the buttons dynamically
    function geo_error(error) {
      let errorMessage = '';
      let primaryButtonText = '';
      let primaryButtonDataActionAttr = '';

      switch(error.code) {
        case error.PERMISSION_DENIED:
          errorMessage = 'You have blocked this site from accessing your location.';
          primaryButtonText = 'Learn How To Unblock Location Access';
          primaryButtonDataActionAttr = 'unblock_location';
          break;
        case error.POSITION_UNAVAILABLE:
          errorMessage = 'Your location information is currently unavailable. Please try again.';
          primaryButtonText = 'Try Again';
          primaryButtonDataActionAttr = 'try_again';
          break;
        case error.TIMEOUT:
          errorMessage = 'The request to get your location took too long. Please try again.';
          primaryButtonText = 'Try Again';
          primaryButtonDataActionAttr = 'try_again';
          break;
        case error.UNKNOWN_ERROR:
          errorMessage = 'An unknown error occurred while trying to access your location. Please try again.';
          primaryButtonText = 'Try Again';
          primaryButtonDataActionAttr = 'try_again';
          break;
      }

      const isIE = /*@cc_on!@*/false || !!document.documentMode;
      const isEdge = !isIE && !!window.StyleMedia;

      if ( (isIE || isEdge) && primaryButtonText === 'Try Again' ) {
        primaryButtonText = 'Please Try the Search Again';
      }

      // place message about no results in place of map
      const noMapHtml = `<div class="epionce-near-you__map-loader"><div class="epionce-near-you__map-loader__options"><a class="epionce-near-you__map-loader__options__primary-button" href="#" data-action="${primaryButtonDataActionAttr}">${primaryButtonText}</a><br><p class="epionce-near-you__map-loader__options__or-text">OR</p><a class="epionce-near-you__map-loader__options__secondary-button" href="#">Click here to show a zipcode field on the search form</a></div></div>`;
      $('#map').html(noMapHtml);

      // show correct messaging in the map loader area
      if ( $('.epionce-near-you__map-loader__options__error-message').length ) {
        $('.epionce-near-you__map-loader__options__error-message').text(errorMessage);
      } else {
        $('.epionce-near-you__map-loader__options').prepend(`<p class="epionce-near-you__map-loader__options__error-message">${errorMessage}</p>`);
      }

      // show correct messaging on for search button
      $('#epionce-near-you-search-button').html('Search');

      if (typeof window.watchId !== 'undefined' && window.watchId !== null && window.watchId !== '') {
        // stop refreshing by location to fix constant refresh issue in Firefox and Safari
        navigator.geolocation.clearWatch(window.watchId);
      }
    }

    // function to connect a user to a pro via Connect button click
    function saveProfessionalCodeToUserAccount_buttonClick(buttonClass, clickedConnectButtonId) {
      // get the professional code from the button id
      const professionalCodeArray = clickedConnectButtonId.split('_');
      const professionalCode = professionalCodeArray[1];

      // give the button a spinner
      $(`#${clickedConnectButtonId}`).html('<i class="far fa-spinner fa-pulse"></i>');

      // create the AJAX promise
      const $promise = $.ajax({
        url: epionce_near_you.ajaxUrl,
        method: 'post',
        dataType: 'json',
        data: {'json': {professionalCode}, 'security': epionce_near_you.nonce, 'action': 'saveProfessionalCodeToUserAccount'}
      });

      // fulfilled promise with success
      $promise.done((response, textStatus, jqXhr) => {

        if (response.status === 'fail') {
          $(`#${clickedConnectButtonId}`).html('Connect');
          alert(response.data.proCode);
        } else if (response.status === 'success') {
          // find all Connect buttons, remove the connected class and replace text with Connect
          $(`.${buttonClass}`).each(function(i,e){
            $(this).removeClass('connected').html('Connect');
          });

          // add the connected class to the clicked button
          $(`#${clickedConnectButtonId}`).html('Connected').addClass('connected');
        }
      });

      // fulfilled promise with error
      $promise.fail((jqXhr, textStatus, errorThrown) => {
        console.log(jqXhr);
        console.log(textStatus);
        console.log(errorThrown);
        $(`#${clickedConnectButtonId}`).html('Try Again');

        setTimeout(() => {
          $(`#${clickedConnectButtonId}`).html('Connect');
        },2000);
      });
    }




    ////////////////////
    // Event Handlers //
    ////////////////////

    $.when(
      // $.getScript( 'https://maps.googleapis.com/maps/api/js?key=' + epionce_near_you.google_maps_api_key ),
      $.Deferred(function( deferred ){
        $( deferred.resolve );
      })
    ).done(function(){
      console.log('gmaps loaded');
      $.when(
        // $.getScript( epionce_near_you.markerwithlabel_path ),
        // $.getScript( epionce_near_you.oms_path ),
        $.Deferred(function( deferred ){
            $( deferred.resolve );
        })
      ).done(function(){
        console.log('markerwithlabel and oms loaded');
        // search button presses
        $('#epionce-near-you-search-button').on('click',function(e){
          e.preventDefault();
    
          // clear any left over search radii from extended radius searches
          if (typeof window.epionceNearYouSearchRadius !== 'undefined' && window.epionceNearYouSearchRadius !== null && window.epionceNearYouSearchRadius !== '') {
            window.epionceNearYouSearchRadius = '';
          }
    
          $(this).html('<i class="far fa-spinner fa-pulse"></i>');
    
          // if professional code is filled in, give it priority
          if ( $('#professional-code').val() !== '' && $('#professional-code').val() !== null && typeof $('#professional-code').val() !== 'undefined' ) {
            // search by professional code
            searchByProfessionalCode($('#professional-code').val());
          } else if ( typeof $('#zipcode').val() !== 'undefined' && $('#zipcode').val() !== null && $('#zipcode').val() !== ''  ) {
            var locationSelection = $('#location').val();
            // check which location option is selected
            if (locationSelection === 'add_zipcode') {
    
              // if add_zipcode, grab the #zipcode value
              var zipcode = $('#zipcode').val();
              var radius = $('#search-radius').val();
              searchByZipcode(zipcode, radius);
            }
          } else if ( $('#business-name').val() !== '' && $('#business-name').val() !== null && typeof $('#business-name').val() !== 'undefined' ) { // search by professional name secondarily
            // search by professionals name
            searchByProfessionalName($('#business-name').val());
          } else {
            var locationSelection = $('#location').val();
            // check which location option is selected
            if (locationSelection === 'current_location') {
              // if current_location, run trackLocation()
    
              // delete any values leftover here
              window.epionce_near_you_professional_name = '';
              window.epionce_near_you_professional_code = '';
    
              // initialize the geo options object
              const geo_options = {
                enableHighAccuracy: true,
                maximumAge        : 30000,
                timeout           : 30000
              };
              window.watchId = trackLocation(geo_options);
            } else if (locationSelection === 'add_zipcode') {
    
              // if add_zipcode, grab the #zipcode value
              var zipcode = $('#zipcode').val();
              var radius = $('#search-radius').val();
              searchByZipcode(zipcode, radius);
            }
          }
        });
    
        // changes in the Location dropdown menu
        $('#location').on('change',function(e){
          if ( $(this).val() === 'add_zipcode' ) {
            if ( $('#zipcode').hasClass('hidden') ) {
              $('#zipcode').removeClass('hidden');
              $('[for="zipcode"]').removeClass('hidden');
            }
          } else {
            if ( !$('#zipcode').hasClass('hidden') ) {
              $('#zipcode').addClass('hidden');
              $('[for="zipcode"]').addClass('hidden');
            }
          }
          google_map_resize();
        });
    
        // hiding the first-time use info modal about location tracking
        $('#currentPositionModal').on('hidden.bs.modal', e => {
          e.preventDefault();
    
          // clear any left over search radii from extended radius searches
          if (typeof window.epionceNearYouSearchRadius !== 'undefined' && window.epionceNearYouSearchRadius !== null && window.epionceNearYouSearchRadius !== '') {
            window.epionceNearYouSearchRadius = '';
          }
    
          // set geo_options
          const geo_options = {
            enableHighAccuracy: true,
            maximumAge        : 30000,
            timeout           : 30000
          };
    
          // execute the location tacking code regardless of whether the user has Allowed or Blocked (it will be handled correctly either way)
          window.watchId = trackLocation(geo_options);
        });
    
        // event handler for the primary button in the map loader area
        $('#map').on('click', '.epionce-near-you__map-loader__options__primary-button', function(e){
          e.preventDefault();
    
          // clear any left over search radii from extended radius searches
          if (typeof window.epionceNearYouSearchRadius !== 'undefined' && window.epionceNearYouSearchRadius !== null && window.epionceNearYouSearchRadius !== '') {
            window.epionceNearYouSearchRadius = '';
          }
    
          // capture the actual target of the click
          const target = e.target || e.srcElement;
    
          // set geo_options
          const geo_options = {
            enableHighAccuracy: true,
            maximumAge        : 30000,
            timeout           : 30000
          };
    
          // figure out what to do
          const dataAction = $(this).attr('data-action');
    
          if (dataAction === 'unblock_location') {
            $('#unblockLocationAccessModal').modal({"show":true});
          } else if (dataAction === 'try_again') {
            window.watchId = trackLocation(geo_options);
          }
        });
    
        // event handler for the secondary button in the map loader area
        $('#map').on('click', '.epionce-near-you__map-loader__options__secondary-button', e => {
          e.preventDefault();
    
          // automatically select the Manually Enter Zipcode option from dropdown in search form
          $('#location').val('add_zipcode');
    
          // remove hidden classes from zipcode label and input fields
          $('#zipcode, [for="zipcode"]').removeClass('hidden');
    
          // resize the map
          google_map_resize();
    
          // put focus on zipcode input
          $('#zipcode').focus();
    
          let i = 0;
          const interval = setInterval(() => {
            if (i === 3) {
              clearInterval(interval);
            }
    
            if (!$('#zipcode').hasClass('pink-border')) {
              $('#zipcode').addClass('pink-border');
            } else {
              $('#zipcode').removeClass('pink-border');
            }
    
            i++;
          }, 250);
        });
    
        // event handler for the ewxtend radius link that appears
        // if no results are found with largest search radius
        $('#map').on('click', '.epionce-near-you__map-loader__options__extend-radius-button', function (e) {
          e.preventDefault();
    
          $(this).html('<i class="far fa-spinner fa-pulse"></i>');
    
          var radius = parseInt( $(this).attr('data-radius') );
          window.epionceNearYouSearchRadius = radius;
    
          // if professional code is filled in, give it priority
          if ( $('#professional-code').val() !== '' && $('#professional-code').val() !== null && typeof $('#professional-code').val() !== 'undefined' ) {
            // search by professional code
            searchByProfessionalCode($('#professional-code').val());
          } else if ( typeof $('#zipcode').val() !== 'undefined' && $('#zipcode').val() !== null && $('#zipcode').val() !== ''  ) {
            var locationSelection = $('#location').val();
            // check which location option is selected
            if (locationSelection === 'add_zipcode') {
    
              // if add_zipcode, grab the #zipcode value
              var zipcode = $('#zipcode').val();
              var radius = parseInt( $(this).attr('data-radius') );
              searchByZipcode(zipcode, radius);
            }
          } else if ( $('#business-name').val() !== '' && $('#business-name').val() !== null && typeof $('#business-name').val() !== 'undefined' ) { // search by professional name secondarily
            // search by professionals name
            searchByProfessionalName($('#business-name').val());
          } else {
            var locationSelection = $('#location').val();
            // check which location option is selected
            if (locationSelection === 'current_location') {
              // if current_location, run trackLocation()
    
              // delete any values leftover here
              window.epionce_near_you_professional_name = '';
              window.epionce_near_you_professional_code = '';
    
              // initialize the geo options object
              const geo_options = {
                enableHighAccuracy: true,
                maximumAge        : 30000,
                timeout           : 30000
              };
              window.watchId = trackLocation(geo_options);
            } else if (locationSelection === 'add_zipcode') {
    
              // if add_zipcode, grab the #zipcode value
              var zipcode = $('#zipcode').val();
              var radius = $(this).attr('data-radius');
              searchByZipcode(zipcode, radius);
            }
          }
        });
    
        // event handler for the Connect button clicks
        $('#professional-listings-container').on('click', '.epionce-near-you__professional-listing__connect-button', e => {
          e.preventDefault();
    
          const target = e.target || e.srcElement;
    
          // get the button id
          const buttonId = $(target).attr('id');
    
          // save the pro code to the users account or user preferences session entry
          saveProfessionalCodeToUserAccount_buttonClick('epionce-near-you__professional-listing__connect-button', buttonId);
        });
      });
    });





    ////////////////////////////////
    // PRELIMINARY INITIALIZATION //
    ////////////////////////////////

    // make map the same height as form container right away
    // google_map_resize();

    // first off, append the Google Map API library loader to the page
    // $('body').append('<script src="https://maps.googleapis.com/maps/api/js?key=' + epionce_near_you.google_maps_api_key + '" async defer></script>');
    // $('body').append('<script async defer src="https://maps.googleapis.com/maps/api/js?key=' + epionce_near_you.google_maps_api_key + '" type="text/javascript"></script>');


    ////////////
    // ONLOAD //
    ////////////

    $(window).load(() => {
      google_map_resize();

      // begin finding the users location using Location API
      if ("geolocation" in navigator) {
        console.log('geolocation is available');
        // geolocation is available

        // check if we've already shown the location tracking custom preliminary modal
        const locationModalShown = getCookie('locationModalShown');

        // initialize the watchId outside the event handler - keep global
        window.watchId = null;


        const isIE = /*@cc_on!@*/false || !!document.documentMode;
        const isEdge = !isIE && !!window.StyleMedia;

        if ( isIE || isEdge ) {
          $('.epionce-near-you__map-loader__options__primary-button').text('Search for Providers Using the Form');
        }

        // show the preliminary location tracking modal if it has not yet been shown
        if ( !locationModalShown ) {
          $('#currentPositionModal').modal({"show":true});

          // set the cookie so the modal does not show again on this device
          setCookie('locationModalShown', true, 365);
        } else {
          // initialize the geo options object
          const geo_options = {
            enableHighAccuracy: true,
            maximumAge        : 30000,
            timeout           : 30000
          };
          // execute the location tacking code regardless of whether the user has Allowed or Blocked (it will be handled correctly either way)
          window.watchId = trackLocation(geo_options);
        }

      } else {
        // geolocation IS NOT available, just show the "Manually Enter Zipcode" button in loader area
        const noMapHtml = '<div class="epionce-near-you__map-loader">'+
                              '<div class="epionce-near-you__map-loader__options">'+
                                '<p>Automatic Geolocation is not available in your browser.</p>'+
                                '<a class="epionce-near-you__map-loader__options__secondary-button" href="#">Click here to show a zipcode field on the search form</a>'+
                              '</div>'+
                            '</div>';
        $('#map').html(noMapHtml);
      }
    });
  },
  finalize() {
    // JavaScript to be fired on the Epionce Near You page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/epionceNearYou.js